import { TranslationComponent } from '../../translations/translation-component';
import { version } from '../../version.js';

const [ MAJOR_VERSION ] = version.split('.');

export const ATTRIBUTES = {
    language: 'language',
    sentiment: 'sentiment'
};

const SentimentMapping = {
    'p': 'positive',
    'v': 'negative',
    'n': 'neutral',
    'u': 'not-rated'
};

export class PrDocumentCardSentiment extends HTMLElement {
    #sentiment = 'u';

    static get tagName() {
        return `pr-document-card-sentiment-v${MAJOR_VERSION}`;
    }

    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    static get observedAttributes() {
        return [
            ATTRIBUTES.language,
            ATTRIBUTES.sentiment
        ];
    }

    attributeChangedCallback(name, __, newValue) {
        if (name === ATTRIBUTES.sentiment) {
            const convertedValue = newValue.toLowerCase();

            if (Object.keys(SentimentMapping).includes(convertedValue)) {
                this.#sentiment = convertedValue;
            } else {
                throw new TypeError(`Invalid sentiment value: ${newValue}`);
            }
        }

        this.#render();
    }

    get language() {
        return this.getAttribute(ATTRIBUTES.language);
    }

    set language (value) {
        this.setAttribute(ATTRIBUTES.language, value);
    }

    get sentiment() {
        return this.#sentiment;
    }

    set sentiment(value) {
        if (Object.keys(SentimentMapping).includes(value)) {
            this.setAttribute(ATTRIBUTES.sentiment, value);
        } else {
            throw new TypeError(`Invalid sentiment value: ${value}`);
        }
    }

    connectedCallback() {
        this.#render();
    }

    #render() {
        this.shadowRoot.innerHTML = /*html*/`
            <style>
                :host {
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    justify-content: center;
                    font-size: 10px;
                    line-height: 1.1em;
                }

                .sentiment {
                    border-radius: 50%;
                    border: 1px solid;
                    height: 6px;
                    width: 6px;
                }

                .positive {
                    border-color: var(--flux-color-green);
                }

                .negative {
                    border-color: var(--flux-color-red);
                }

                .neutral, .not-rated {
                    border-color: var(--flux-color-gray-700);
                }
            </style>
            <div class="sentiment ${SentimentMapping[this.#sentiment]}">
                <flux-tooltip>
                    <${TranslationComponent.tagName} key="pr-document-visualizations__sentiment--${SentimentMapping[this.#sentiment]}" language="${this.language}"></${TranslationComponent.tagName}>
                </flux-tooltip>
            </div>
        `;
    }
}

if (!customElements.get(PrDocumentCardSentiment.tagName)) {
    customElements.define(PrDocumentCardSentiment.tagName, PrDocumentCardSentiment);
}
